import React, { useState } from "react";
import { userDeatils } from "../../ReactiveVariables/index";
import { useReactiveVar } from "@apollo/client";
import Avatar from "@mui/material/Avatar";
import { Link } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";

import MobileSideMenu from "./mobileSideMenu";
import DialogBox from "./dialogBox";

import { useLogout } from "../../utils/hooks/use-logout";
import { HeaderMenu } from "@components/atoms/header-menu";
import { getUserType } from "@utils/user-format.utils";

export default function MobileHeader(props) {
  const user = useReactiveVar(userDeatils);
  const [openDialog, setOpenDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const open = Boolean(anchorEl);

  const userType = getUserType(user);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { onLogout } = useLogout({
    userType: "",
    logoutCallback: handleClose,
  });

  return (
    <header className="fixed-top LoggedInHeader d-flex d-lg-none">
      {openDialog && (
        <DialogBox
          setOpenDialog={setOpenDialog}
          handleDelete={onLogout}
          openDialog={openDialog}
          title="Logout"
          discription="Are you sure you want to Logout?"
        />
      )}

      <MobileSideMenu
        openSideMenu={openSideMenu}
        setOpenSideMenu={setOpenSideMenu}
        sideMenu={props}
      />
      <div className="container-fluid">
        <IconButton onClick={() => setOpenSideMenu(true)} className="d-block d-lg-none">
          <img
            src="../assets/images/hamburger-menu.svg"
            className="img-fluid hamburger-icon"
            alt="Menu Icon"
          />
        </IconButton>

        <Link to={"/"} className="logo">
          <img src="../assets/images/logo.svg" className="img-fluid" alt="Logo" />
        </Link>
        <div className="header-menu" onClick={handleClick}>
          <Avatar
            className="profile-avatar"
            alt="Remy Sharp"
            src={
              user?.data?.currentUserDetails?.imageUrl
                ? user?.data?.currentUserDetails?.imageUrl
                : user?.data?.login?.imageUrl
                ? user?.data?.login?.imageUrl
                : "/static/images/avatar/1.jpg"
            }
            style={{ cursor: "pointer" }}>
            {user?.data?.login?.fullName.charAt(0).toUpperCase() ||
              user?.data?.currentUserDetails?.name?.charAt(0).toUpperCase() ||
              user?.data?.createCaterer?.fullName?.charAt(0).toUpperCase()}
          </Avatar>
          <h3 style={{ cursor: "pointer" }} className="header-user-name">
            {user?.data?.login?.fullName ||
              user?.data?.currentUserDetails?.name ||
              user?.data?.createCaterer?.fullName}
          </h3>
        </div>
        <HeaderMenu
          element={anchorEl}
          isOpen={open}
          userType={userType}
          onClose={handleClose}
          onLogout={() => setOpenDialog(true)}
        />
      </div>
    </header>
  );
}
